import React from 'react';
import * as utils from '../../../utils';
import ChatHead from '../../ChatHead';
import { TransitionMotion, spring } from 'react-motion';

const AnimatedChatHeads = (props) => {
  const {
    activeConversation,
    changeConversationStatus,
    channels,
    conversations,
    deleteConversation,
    ignoreConversation,
    handleClick,
    screenSize,
    currentFilter,
  } = props;
  let seenStyles = {};

  const willEnter = () => {
    return { height: 0, left: -350, opacity: 0 };
  };

  const willLeave = () => {
    return { height: spring(0), left: spring(350), opacity: spring(0) };
  };

  const chatHeadStyles = conversations
    .map((conversation) => {
      const subjectLine = utils.getSubjectLineIfEmail(conversation, channels);

      return {
        key: String(conversation.id),
        data: {
          conversation,
          handleClick: () =>
            handleClick(conversation, conversation.unread_count),
          collapsed: ['xs', 'sm', 'md'].indexOf(screenSize) !== -1,
          isClosed: conversation.status === 'closed',
          subjectLine,
        },
        style: {
          height: spring(200),
          left: spring(0),
          opacity: spring(1),
        },
      };
    })
    .filter((style) => {
      if (!seenStyles[style.key]) {
        seenStyles[style.key] = true;
        return true;
      }
      return false;
    });

  return (
    <TransitionMotion
      willEnter={willEnter}
      willLeave={willLeave}
      styles={chatHeadStyles}
    >
      {(chatHeadStyles) => {
        return (
          <div>
            {chatHeadStyles.map(({ key, data, style }) => {
              const { conversation, handleClick, collapsed, isClosed } = data;
              const componentStyle = {
                position: 'relative',
                opacity: style.opacity,
                height: '100%',
                maxHeight: style.height,
                overflow: 'visible',
                left: style.left,
              };
              return (
                <div key={key} style={componentStyle}>
                  <ChatHead
                    key={key}
                    user_id={conversation.user_id}
                    unreadCount={conversation.unread_count}
                    isActive={activeConversation === conversation.id}
                    isClosed={isClosed}
                    conversation={conversation}
                    lastMessageChannel={conversation.last_message_channel}
                    lastMessageTimestamp={conversation.last_message_time}
                    changeConversationStatus={changeConversationStatus}
                    onClick={handleClick}
                    collapsed={collapsed}
                    deleteConversation={deleteConversation}
                    ignoreConversation={ignoreConversation}
                    subjectLine={data.subjectLine}
                    currentFilter={currentFilter}
                  />
                </div>
              );
            })}
          </div>
        );
      }}
    </TransitionMotion>
  );
};

export default AnimatedChatHeads;
